import { IQuote } from '@types';
import { atom } from 'recoil';

/* eslint-disable */
const keys = {
	QUOTE:			'@Ofload/Quote'
}
/* eslint-enable */

export const Quote = atom<IQuote | null>({
	key: keys.QUOTE,
	default: null
});
